import React, { useState } from "react";
import { Table, Select, Button, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import styles from "./CustomerManagementDetails.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { InputField, SearchInput, TextComponent } from "../../../../../components";
import { ReactComponent as DeleteIcon } from "../../../../../assets/images/deleteIcon.svg";
import { ReactComponent as EditIcon } from "../../../../../assets/images/editIcon.svg";
import HeaderComponent from "../../../../../components/HeaderComponent/HeaderComponent";
import TopTabComponent from "../../../../../components/TopTabComponent/TopTabComponent";
import OrderHistory from "../OrderHistory/OrderHistory";
import StandingOrder from "../StandingOrder/StandingOrder";

const CustomerManagementDetails = () => {
    const navigate = useNavigate();

    const options = [
        { id: 1, name: "Order History" },
        { id: 2, name: "Standing Orders" },
    ];

    const [focusedTab, setFocusedTab] = useState(options[0]);


    return (
        <div className={styles.mainCont}>
            <div className={styles.itemsHeadDiv}>
                <HeaderComponent
                    heading={"Joshua Jones"}
                    showBackIcon={true}
                    showControlButtons={true}
                    //   onDelete
                    onEdit={() => navigate("/AdminCustomerManagement/AdminEditCustomer")}

                />
                {/* <div className={styles.itemsButtonDiv}>
                    <DeleteIcon width={20} height={20} />
                    <EditIcon width={20} height={20} />
                </div> */}
                {/* </HeaderComponent> */}
            </div>
            <div className={styles.itemsContDiv}>
                <div className={styles.itemsContDivRow}>
                    <div className={styles.itemsDiv}>

                        <div
                            className={styles.itemLabel}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            <TextComponent
                                text="Location :"
                                style={{
                                    fontFamily: 'Poppins-bold',
                                }}
                            />
                            <TextComponent
                                text="417 Bicetown Road, New York, NY 10018"
                                style={{
                                    fontFamily: 'Poppins-regular',
                                }}
                            />
                        </div>
                    </div>


                    <div className={styles.itemsDiv}>
                        <div
                            className={styles.itemLabel}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >

                            <TextComponent
                                text="Email :"
                                style={{
                                    fontFamily: 'Poppins-bold',
                                }}
                            />
                            <TextComponent
                                text="Joshua@mail.com"
                                style={{
                                    fontFamily: 'Poppins-regular',
                                }}
                            />
                        </div>
                    </div>

                </div>

                <div className={styles.itemsContDivRow}>
                    <div className={styles.itemsDiv} >
                        <div
                            className={styles.itemLabel}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            <TextComponent
                                text="Notes :"
                                style={{
                                    fontFamily: 'Poppins-bold',
                                }}
                            />
                            <TextComponent
                                text=" Delivery before 10am"
                                style={{
                                    fontFamily: 'Poppins-regular',
                                }}
                            />
                        </div>
                    </div>


                    <div className={styles.itemsDiv}>

                        <div
                            className={styles.itemLabel}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            <TextComponent
                                text="Contact :"
                                style={{
                                    fontFamily: 'Poppins-bold',
                                }}
                            />
                            <TextComponent
                                text=" (636) 296-7838"
                                style={{
                                    fontFamily: 'Poppins-regular',
                                }}
                            />
                        </div>

                    </div>



                </div>




            </div>

            <div className={styles.TopTabListStyle}>
                <TopTabComponent
                    options={options}
                    focused={focusedTab}
                    setFocused={setFocusedTab}
                    TopTabListStyle={styles.TopTabListStyle}
                />
            </div>

            {focusedTab?.name === options[0]?.name && <OrderHistory />}
            {focusedTab?.name === options[1]?.name && <StandingOrder />}



        </div>
    );
};

export default CustomerManagementDetails;
